module.exports = __webpack_public_path__ + "img/WESImg.8971a242.png";